import Vue from 'vue';
import Vuex from 'vuex';
import accountModule from '@/store/modules/account/account'
import hitCalculatorModule from '@/store/modules/hit-calculator/hit-calculator';
import equityCalculatorModule from '@/store/modules/equity-calculator/equity-calculator';
import equityMatrixModule from '@/store/modules/equity-matrix/equity-matrix';
import rangeConstructorModule from '@/store/modules/range-constructor/range-constructor';
import guidedAnalysesCallingModule from '@/store/modules/guided-analyses/calling';
import guidedAnalysesBluffingModule from '@/store/modules/guided-analyses/bluffing';
import threeBetCbetExplorerModule from '@/store/modules/three-bet-cbet-explorer/three-bet-cbet-explorer';
import breakevenPercentageForBluffingTheTurnModule from '@/store/modules/breakeven-percentage-for-bluffing-the-turn/breakeven-percentage-for-bluffing-the-turn';
import shortDeckEquityCalculatorModule from '@/store/modules/short-deck/short-deck-equity-calculator';
import shortDeckHitCalculatorModule from '@/store/modules/short-deck/short-deck-hit-calculator';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    account: accountModule,
    hitCalculator: hitCalculatorModule,
    equityCalculator: equityCalculatorModule,
    equityMatrix: equityMatrixModule,
    rangeConstructor: rangeConstructorModule,
    guidedAnalysesCalling: guidedAnalysesCallingModule,
    guidedAnalysesBluffing: guidedAnalysesBluffingModule,
    threeBetCbetExplorer: threeBetCbetExplorerModule,
    breakevenPercentageForBluffingTheTurn: breakevenPercentageForBluffingTheTurnModule,
    shortDeckEquityCalculator: shortDeckEquityCalculatorModule,
    shortDeckHitCalculator: shortDeckHitCalculatorModule,
  }
});



// WEBPACK FOOTER //
// ./src/store/index.js